import React from "react";
import "../../../assests/css/students/BlogsDetail.css";
import { useNavigate } from "react-router-dom";
import TopBlogCard from "../../../components/students/TopBlogCard/TopBlogCard";

const BlogsDetail = () => {
    const navigate = useNavigate();
  return (
    <div className="bd-wrapper">

      {/* Header */}
      <TopBlogCard />
      <div className="bd-header">
        <h2 className="bd-title">Campus Life & Events</h2>
        <p className="bd-subtitle">
          Stay updated with what’s happening around our college
        </p>
      </div>

      {/* Main Blog Content */}
      <div className="bd-content">

        <img
          className="bd-cover"
          src="https://images.unsplash.com/photo-1523050854058-8df90110c9f1"
          alt=""
        />

        <h3 className="bd-heading">A Day in the Life of Our College Campus</h3>

        <p className="bd-text">
          Our college campus is full of life, learning, and creativity. From
          early morning lectures to evening extracurricular activities, students
          experience a balanced academic and social life.
        </p>

        <p className="bd-text">
          The campus offers modern classrooms, a digital library, sports
          facilities, cultural clubs, and regular events that help students grow
          academically and personally.
        </p>

      </div>

      {/* Events Section */}
      <div className="bd-events-grid">

        {/* Recent Events */}
        {/* <div className="bd-event-card recent">
          <h4>Recent Events</h4>
          <ul>
            <li>🏆 Annual Sports Day – March 2024</li>
            <li>🎭 Cultural Festival Night</li>
            <li>🎓 Convocation Ceremony</li>
            <li>📚 Book Fair & Library Week</li>
          </ul>
        </div> */}

        {/* Upcoming Events */}
        {/* <div className="bd-event-card upcoming">
          <h4>Upcoming Events</h4>
          <ul>
            <li>⚽ Inter-College Sports Tournament</li>
            <li>🎉 Fun Fair & Food Festival</li>
            <li>🎤 Career Counseling Seminar</li>
            <li>🎨 Art & Science Exhibition</li>
          </ul>
        </div> */}

      </div>

      {/* Footer CTA */}
      <div className="bd-footer">
        <button className="bd-back-btn" onClick={() => navigate("/blogs")}>← Back to Blogs</button>
      </div>

    </div>
  );
};

export default BlogsDetail;
